import React from "react";
import { PaymentDiscountRegistrationApi, useDiscountRegistrations } from "api/payment-discounts";
import { PaziaBox } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";

export const DiscountRegistrationsList = ({ paymentDiscountId }: { paymentDiscountId: number }) => {
  const { isLoading, registrations } = useDiscountRegistrations(paymentDiscountId);

  const columns: TanTableColumn<PaymentDiscountRegistrationApi>[] = [
    {
      id: "paymentDiscountRegistrationId",
      accessorKey: "paymentDiscountRegistrationId",
      header: "Id",
      size: 10,
    },
    {
      id: "originalPrice",
      accessorKey: "originalPrice",
      header: "Cena oryginalna",
    },
    {
      id: "discountedPrice",
      accessorKey: "discountedPrice",
      header: "Cena po rabacie",
    },
    {
      id: "userEmail",
      accessorKey: "userEmail",
      header: "Email",
    },
    {
      id: "userFirstName",
      accessorKey: "userFirstName",
      header: "Imię",
    },
    {
      id: "userSurname",
      accessorKey: "userSurname",
      header: "Nazwisko",
    },
    {
      id: "courseId",
      accessorKey: "courseId",
      header: "Id kursu",
    },
    {
      id: "courseName",
      accessorKey: "courseName",
      header: "Nazwa kursu",
    },
  ];
  return (
    <PaziaBox className="mt-8" header="Lista użyć">
      <TanTableClient data={registrations} columns={columns} hideBorder />
    </PaziaBox>
  );
};
